// extracted by mini-css-extract-plugin
module.exports = {"component":"share-links_component__qpR3s","icon":"share-links_icon__1lQWp"};